import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ORDER_STATUSES_DICTIONARY_SUCCESS:
      return { ...action.orderStatuses };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/order-statuses-dictionary.js